export default __webpack_public_path__ + "static/media/commision-earned.a1feefa6.png";